import { useEffect } from 'react'
import { getRole } from '../../utils/getRole'
import {
  listenWebPushClientEvents,
  syncWebPushSubscription,
} from '../../utils/webPush'

function WebPushSession() {
  const { isClient } = getRole()

  useEffect(() => {
    if (isClient) {
      return
    }

    syncWebPushSubscription()
    return listenWebPushClientEvents()
  }, [isClient])

  return null
}

export default WebPushSession
